<div class="uni-form-multi-autocomplete-header">
  <div class="uni-form-multi-autocomplete-header__name" (click)="onClose()">
    <uni-text-caption>{{ heading }}</uni-text-caption>
    <div class="uni-form-multi-autocomplete-header__quantity" *ngIf="multi && checkedItemsLength">
      <span>{{ checkedItemsLength }}</span>
    </div>
  </div>
  <uni-icon name="times" (click)="onClose()" uniLabelSuffix></uni-icon>
</div>
